module.exports = __webpack_public_path__ + "img/paper-airplane.db807ccf.svg";